import { n as i } from "./_plugin-vue2_normalizer-Bj5bLKV4.mjs";
const l = {
  name: "ChevronDownIcon",
  emits: ["click"],
  props: {
    title: {
      type: String
    },
    fillColor: {
      type: String,
      default: "currentColor"
    },
    size: {
      type: Number,
      default: 24
    }
  }
};
var r = function() {
  var t = this, e = t._self._c;
  return e("span", t._b({ staticClass: "material-design-icon chevron-down-icon", attrs: { "aria-hidden": t.title ? null : !0, "aria-label": t.title, role: "img" }, on: { click: function(n) {
    return t.$emit("click", n);
  } } }, "span", t.$attrs, !1), [e("svg", { staticClass: "material-design-icon__svg", attrs: { fill: t.fillColor, width: t.size, height: t.size, viewBox: "0 0 24 24" } }, [e("path", { attrs: { d: "M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z" } }, [t.title ? e("title", [t._v(t._s(t.title))]) : t._e()])])]);
}, s = [], a = /* @__PURE__ */ i(
  l,
  r,
  s,
  !1,
  null,
  null,
  null,
  null
);
const _ = a.exports;
export {
  _ as C
};
